import * as Yup from "yup";

import {StatusPageLayoutPreset, StatusPageTheme} from "@/lib/types/statuspages.ts";
import {StatusPageDesignTabFormValues} from "@/pages/statuspages/tabs/design/StatusPageDesignTab.types.ts";

export const StatusPageDesignTabSchema = Yup.object({
  logo: Yup.mixed<FileList>().nullable(),
  favicon: Yup.mixed<FileList>().nullable(),
  company_website_url: Yup.string().optional(),
  custom_css: Yup.string().optional(),
  custom_header_html: Yup.string().optional(),
  custom_footer_html: Yup.string().optional(),
  custom_css_inspire: Yup.string().optional(),
  custom_header_html_inspire: Yup.string().optional(),
  custom_footer_html_inspire: Yup.string().optional(),
  custom_header_text_color_hex: Yup.string().defined(),
  custom_header_bg_color_hex: Yup.string().defined(),
  theme: Yup.string<StatusPageTheme>().required(),
  email_logo: Yup.mixed<FileList>().nullable(),
  layout_preset: Yup.string<StatusPageLayoutPreset>().required(),
  show_component_bars: Yup.boolean().required(),
  show_component_descriptions: Yup.boolean().required(),
});

export const StatusPageDesignTabDefaultValues: StatusPageDesignTabFormValues = {
  logo: null,
  favicon: null,
  company_website_url: "",
  custom_css: "",
  custom_header_html: "",
  custom_footer_html: "",
  custom_css_inspire: "",
  custom_header_html_inspire: "",
  custom_footer_html_inspire: "",
  custom_header_text_color_hex: "#FFFFFF",
  custom_header_bg_color_hex: "#002E52",
  theme: StatusPageTheme.INSPIRE,
  email_logo: null,
  layout_preset: StatusPageLayoutPreset.EXPANDED,
  show_component_bars: false,
  show_component_descriptions: true,
};
